// landingpage/src/Components/about-page/free-trial/freeTrial.css
// import React from 'react';
// import './freeTrial.css';
// import OrangeButton from '../../buttons/orange-button';
// import { useNavigate } from 'react-router-dom';
// const FreeTrial = () => {
//   const navigate = useNavigate();
//   return (
//     <div className="free-trial !p-5 !pt-6">
//       <div className="max-w-[502px] md:pl-10 md:pt-10">
//         <h2 className="fredokaOne text-center text-[32px] font-normal   leading-tight tracking-[-0.64px] text-white md:text-left md:text-[40px] md:tracking-[-0.8px]">
//           Leverage AI and Individualized Support to Realize your full potential! Get Early Access to Our Exclusive Educator Community!
//         </h2>
//         <div className="ft-btn-container mt-6">
//           <OrangeButton
//             className="!text-base leading-normal"
//             onClick={() => navigate('/waitlist')}
//             label={'Start Free Trial'}
//           />
//         </div>
//       </div>
//       <div className="free-trial-box-parent">
//         <div className="free-trial-box ">

//                 <p className="text-white text-center md:text-left mt-4 text-lg">
//                 Enjoy personalized support directly from our founder as part of our premium Concierge MVP.
//               </p>
//           <h4 className="fredokaOne ">Get early access to our Concierge MVP and receive personalized support</h4>
//           <p className="fredokaOne">directly from our founder</p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default FreeTrial;

// // landingpage/src/Components/about-page/free-trial/freeTrial.jsx
// import React from 'react';
// import './freeTrial.css';
// import OrangeButton from '../../buttons/orange-button';
// import { useNavigate } from 'react-router-dom';

// const FreeTrial = () => {
//   const navigate = useNavigate();
//   return (
//     <div className="free-trial !p-5 !pt-6">
//       <div className="max-w-[502px] md:pl-10 md:pt-10">
//         <h1 className="fredokaOne text-center text-[32px] font-normal leading-tight tracking-[-0.64px] text-white md:text-left md:text-[40px] md:tracking-[-0.8px]">
//           Join our exclusive educator community today!
//         </h1>
//         <p className="text-center text-white mt-4 md:text-left text-[16px]">
          
//         </p>
//         <div className="ft-btn-container mt-6">
//           <OrangeButton
//             className="!text-base leading-normal"
//             onClick={() => navigate('/waitlist')}
//             label={'Join Waitlist'}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default FreeTrial;

// landingpage/src/Components/about-page/free-trial/freeTrial.jsx
// landingpage/src/Components/about-page/free-trial/freeTrial.jsx
// import React from 'react';
// import './freeTrial.css';
// import OrangeButton from '../../buttons/orange-button';
// import { useNavigate } from 'react-router-dom';

// const FreeTrial = () => {
//   const navigate = useNavigate();

//   return (
//     <div className="free-trial">
//       <div className="free-trial-content">
//         <div className="free-trial-text">
//           <h1>Get Early Access to Our Exclusive Educator Community</h1>
//           <p>Enjoy personalized support directly from our founder as part of our premium Concierge MVP. 
//             It&apos;s free & no credit card required.</p>
//           <div className="ft-btn-container">
//             <OrangeButton
//               className="!text-base leading-normal"
//               onClick={() => navigate('/waitlist')}
//               label={'Join Our Waitlist'}
//             />
//           </div>
//         </div>
//         <div className="free-trial-image-container">
//           {/* <img
//             src="/images/about/free-trial-img-1.png"
//             alt="Educator Illustration"
//             className="free-trial-image"
//           /> */}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default FreeTrial;
import React from 'react';
import './freeTrial.css';
import OrangeButton from '../../buttons/orange-button';
import { useNavigate } from 'react-router-dom';

const FreeTrial = () => {
  const navigate = useNavigate();

  return (
    <div className="free-trial">
      <div className="free-trial-content">
        <div className="free-trial-text">
          <br/>
          <h1>Act Now to Get Early Access to Our Exclusive Educator Community!</h1>

          <div className="ft-btn-container">
            <OrangeButton
              className="!text-base leading-normal"
              onClick={() => navigate('/waitlist')}
              label={'Join Our Waitlist'}
            />
          </div>
        </div>

        {/* Replace the previous yellow box with styled support text */}
        <div className="free-trial-box">
          <h4>
            Enjoy personalized support{' '}
            <span className="highlight-orange">directly from our founder</span> as part of our
            premium Concierge MVP.
          </h4>
        </div>
      </div>
    </div>
  );
};

export default FreeTrial;

